import { formatDuration, calculateMedian, extractUrgentReadTimes, extractCallbackTimes, extractCallbackDurations, countUrgentInteractions, countRoutineInteractions, countVoicemailInteractions, countCallbackInteractions, countTransferInteractions, countUniquePractices, } from "./executiveSummaryUtils";
import { calculateKPIMetrics } from "./kpiCalculationUtils";
export const generateAggregateAccountName = (selectedUserNames, selectedAccountNames) => {
    if (selectedUserNames.length > 0 && selectedAccountNames.length > 0) {
        return "All Selected Accounts & Users";
    }
    if (selectedUserNames.length > 0) {
        return "All Selected Users";
    }
    return "All Selected Accounts";
};
export const calculateAccountMetrics = (filteredAccountGroups, kpiResult) => {
    return filteredAccountGroups.map(([accountName, accountInteractions]) => {
        const totalInteractions = accountInteractions.length;
        const urgent = countUrgentInteractions(accountInteractions);
        const routine = countRoutineInteractions(accountInteractions);
        const practices = countUniquePractices(accountInteractions);
        const urgentReadTimes = extractUrgentReadTimes(accountInteractions);
        const avgUrgentReadTimeSeconds = urgentReadTimes.length > 0 ? urgentReadTimes.reduce((sum, time) => sum + time, 0) / urgentReadTimes.length : 0;
        const medianUrgentReadTimeSeconds = urgentReadTimes.length > 0 ? calculateMedian(urgentReadTimes) : 0;
        const avgUrgentReadTime = formatDuration(avgUrgentReadTimeSeconds);
        const medianUrgentReadTime = formatDuration(medianUrgentReadTimeSeconds);
        const callbackCount = countCallbackInteractions(accountInteractions);
        const callbackTimes = extractCallbackTimes(accountInteractions);
        const avgCallbackTimeSeconds = callbackTimes.length > 0 ? callbackTimes.reduce((sum, time) => sum + time, 0) / callbackTimes.length : 0;
        const medianCallbackTimeSeconds = callbackTimes.length > 0 ? calculateMedian(callbackTimes) : 0;
        const avgCallbackTime = formatDuration(avgCallbackTimeSeconds);
        const medianCallbackTime = formatDuration(medianCallbackTimeSeconds);
        const callbackDurations = extractCallbackDurations(accountInteractions);
        const avgCallbackDurationSeconds = callbackDurations.length > 0
            ? callbackDurations.reduce((sum, duration) => sum + duration, 0) / callbackDurations.length
            : 0;
        const medianCallbackDurationSeconds = callbackDurations.length > 0 ? calculateMedian(callbackDurations) : 0;
        const avgCallbackDuration = formatDuration(avgCallbackDurationSeconds);
        const medianCallbackDuration = formatDuration(medianCallbackDurationSeconds);
        const voicemails = countVoicemailInteractions(accountInteractions);
        const transfers = countTransferInteractions(accountInteractions);
        let kpiMetrics;
        if (kpiResult) {
            kpiMetrics = calculateKPIMetrics(accountInteractions, kpiResult);
        }
        return {
            accountName,
            practices,
            totalInteractions,
            urgent,
            routine,
            avgUrgentReadTime,
            medianUrgentReadTime,
            avgCallbackTime,
            medianCallbackTime,
            avgCallbackDuration,
            medianCallbackDuration,
            avgUrgentReadTimeSeconds,
            medianUrgentReadTimeSeconds,
            avgCallbackTimeSeconds,
            medianCallbackTimeSeconds,
            avgCallbackDurationSeconds,
            medianCallbackDurationSeconds,
            callbackCount,
            voicemails,
            transfers,
            isBackup: 0,
            isForward: 0,
            kpiExcellent: kpiMetrics === null || kpiMetrics === void 0 ? void 0 : kpiMetrics.excellent,
            kpiGood: kpiMetrics === null || kpiMetrics === void 0 ? void 0 : kpiMetrics.good,
            kpiAcceptable: kpiMetrics === null || kpiMetrics === void 0 ? void 0 : kpiMetrics.acceptable,
            kpiPoor: kpiMetrics === null || kpiMetrics === void 0 ? void 0 : kpiMetrics.poor,
            kpiExcellentPercent: kpiMetrics === null || kpiMetrics === void 0 ? void 0 : kpiMetrics.excellentPercent,
            kpiGoodPercent: kpiMetrics === null || kpiMetrics === void 0 ? void 0 : kpiMetrics.goodPercent,
            kpiAcceptablePercent: kpiMetrics === null || kpiMetrics === void 0 ? void 0 : kpiMetrics.acceptablePercent,
            kpiPoorPercent: kpiMetrics === null || kpiMetrics === void 0 ? void 0 : kpiMetrics.poorPercent,
            isTotal: false,
        };
    });
};
export const calculateUserMetrics = (filteredUserGroups, selectedUserNames, kpiResult) => {
    if (selectedUserNames.length === 0) {
        return [];
    }
    return filteredUserGroups
        .filter(([userName]) => selectedUserNames.includes(userName))
        .map(([userName, userInteractions]) => {
        const totalInteractions = userInteractions.length;
        const urgent = countUrgentInteractions(userInteractions);
        const routine = countRoutineInteractions(userInteractions);
        const practices = countUniquePractices(userInteractions);
        const urgentReadTimes = extractUrgentReadTimes(userInteractions);
        const avgUrgentReadTimeSeconds = urgentReadTimes.length > 0 ? urgentReadTimes.reduce((sum, time) => sum + time, 0) / urgentReadTimes.length : 0;
        const medianUrgentReadTimeSeconds = urgentReadTimes.length > 0 ? calculateMedian(urgentReadTimes) : 0;
        const avgUrgentReadTime = formatDuration(avgUrgentReadTimeSeconds);
        const callbackCount = countCallbackInteractions(userInteractions);
        const callbackTimes = extractCallbackTimes(userInteractions);
        const avgCallbackTimeSeconds = callbackTimes.length > 0 ? callbackTimes.reduce((sum, time) => sum + time, 0) / callbackTimes.length : 0;
        const medianCallbackTimeSeconds = callbackTimes.length > 0 ? calculateMedian(callbackTimes) : 0;
        const avgCallbackTime = formatDuration(avgCallbackTimeSeconds);
        const callbackDurations = extractCallbackDurations(userInteractions);
        const avgCallbackDurationSeconds = callbackDurations.length > 0
            ? callbackDurations.reduce((sum, duration) => sum + duration, 0) / callbackDurations.length
            : 0;
        const medianCallbackDurationSeconds = callbackDurations.length > 0 ? calculateMedian(callbackDurations) : 0;
        const avgCallbackDuration = formatDuration(avgCallbackDurationSeconds);
        const voicemails = countVoicemailInteractions(userInteractions);
        const transfers = countTransferInteractions(userInteractions);
        let kpiMetrics;
        if (kpiResult) {
            kpiMetrics = calculateKPIMetrics(userInteractions, kpiResult);
        }
        return {
            accountName: `👤 ${userName}`,
            practices,
            totalInteractions,
            urgent,
            routine,
            avgUrgentReadTime,
            medianUrgentReadTime: formatDuration(medianUrgentReadTimeSeconds),
            avgCallbackTime,
            medianCallbackTime: formatDuration(medianCallbackTimeSeconds),
            avgCallbackDuration,
            medianCallbackDuration: formatDuration(medianCallbackDurationSeconds),
            avgUrgentReadTimeSeconds,
            medianUrgentReadTimeSeconds,
            avgCallbackTimeSeconds,
            medianCallbackTimeSeconds,
            avgCallbackDurationSeconds,
            medianCallbackDurationSeconds,
            callbackCount,
            voicemails,
            transfers,
            isBackup: 0,
            isForward: 0,
            kpiExcellent: kpiMetrics === null || kpiMetrics === void 0 ? void 0 : kpiMetrics.excellent,
            kpiGood: kpiMetrics === null || kpiMetrics === void 0 ? void 0 : kpiMetrics.good,
            kpiAcceptable: kpiMetrics === null || kpiMetrics === void 0 ? void 0 : kpiMetrics.acceptable,
            kpiPoor: kpiMetrics === null || kpiMetrics === void 0 ? void 0 : kpiMetrics.poor,
            kpiExcellentPercent: kpiMetrics === null || kpiMetrics === void 0 ? void 0 : kpiMetrics.excellentPercent,
            kpiGoodPercent: kpiMetrics === null || kpiMetrics === void 0 ? void 0 : kpiMetrics.goodPercent,
            kpiAcceptablePercent: kpiMetrics === null || kpiMetrics === void 0 ? void 0 : kpiMetrics.acceptablePercent,
            kpiPoorPercent: kpiMetrics === null || kpiMetrics === void 0 ? void 0 : kpiMetrics.poorPercent,
            isTotal: false,
        };
    });
};
export const calculateAggregateMetrics = (interactions, selectedUserNames, selectedAccountNames, kpiResult) => {
    const urgentReadTimes = extractUrgentReadTimes(interactions);
    const aggregateAvgUrgentReadTimeSeconds = urgentReadTimes.length > 0 ? urgentReadTimes.reduce((sum, time) => sum + time, 0) / urgentReadTimes.length : 0;
    const aggregateMedianUrgentReadTimeSeconds = urgentReadTimes.length > 0 ? calculateMedian(urgentReadTimes) : 0;
    const callbackTimes = extractCallbackTimes(interactions);
    const aggregateAvgCallbackTimeSeconds = callbackTimes.length > 0 ? callbackTimes.reduce((sum, time) => sum + time, 0) / callbackTimes.length : 0;
    const aggregateMedianCallbackTimeSeconds = callbackTimes.length > 0 ? calculateMedian(callbackTimes) : 0;
    const callbackDurations = extractCallbackDurations(interactions);
    const aggregateAvgCallbackDurationSeconds = callbackDurations.length > 0
        ? callbackDurations.reduce((sum, duration) => sum + duration, 0) / callbackDurations.length
        : 0;
    const aggregateMedianCallbackDurationSeconds = callbackDurations.length > 0 ? calculateMedian(callbackDurations) : 0;
    return {
        accountName: generateAggregateAccountName(selectedUserNames, selectedAccountNames),
        practices: countUniquePractices(interactions),
        totalInteractions: interactions.length,
        urgent: countUrgentInteractions(interactions),
        routine: countRoutineInteractions(interactions),
        avgUrgentReadTime: formatDuration(aggregateAvgUrgentReadTimeSeconds),
        medianUrgentReadTime: formatDuration(aggregateMedianUrgentReadTimeSeconds),
        avgCallbackTime: formatDuration(aggregateAvgCallbackTimeSeconds),
        medianCallbackTime: formatDuration(aggregateMedianCallbackTimeSeconds),
        avgCallbackDuration: formatDuration(aggregateAvgCallbackDurationSeconds),
        medianCallbackDuration: formatDuration(aggregateMedianCallbackDurationSeconds),
        avgUrgentReadTimeSeconds: aggregateAvgUrgentReadTimeSeconds,
        medianUrgentReadTimeSeconds: aggregateMedianUrgentReadTimeSeconds,
        avgCallbackTimeSeconds: aggregateAvgCallbackTimeSeconds,
        medianCallbackTimeSeconds: aggregateMedianCallbackTimeSeconds,
        avgCallbackDurationSeconds: aggregateAvgCallbackDurationSeconds,
        medianCallbackDurationSeconds: aggregateMedianCallbackDurationSeconds,
        callbackCount: countCallbackInteractions(interactions),
        voicemails: countVoicemailInteractions(interactions),
        transfers: countTransferInteractions(interactions),
        isBackup: 0,
        isForward: 0,
        kpiExcellent: kpiResult ? kpiResult.excellentCount : undefined,
        kpiGood: kpiResult ? kpiResult.goodCount : undefined,
        kpiAcceptable: kpiResult ? kpiResult.acceptableCount : undefined,
        kpiPoor: kpiResult ? kpiResult.poorCount : undefined,
        kpiExcellentPercent: kpiResult ? `${Math.round(kpiResult.excellentPct)}%` : undefined,
        kpiGoodPercent: kpiResult ? `${Math.round(kpiResult.goodPct)}%` : undefined,
        kpiAcceptablePercent: kpiResult ? `${Math.round(kpiResult.acceptablePct)}%` : undefined,
        kpiPoorPercent: kpiResult ? `${Math.round(kpiResult.poorPct)}%` : undefined,
        isTotal: false,
    };
};
//# sourceMappingURL=accountSummaryCalculations.js.map